export default "__VITE_ASSET__edba910a__"